import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'chevron-right', 'ChevronRight', [["path",{"d":"M9 6l6 6l-6 6"}]]);